export function getSearchString (key) {
  // 获取URL中?之后的字符
  let addrstr = location.href
  let str = addrstr.substring(addrstr.lastIndexOf('?') + 1, addrstr.length) // shopcode=125806649&branchcode=001&recommendid=6&openidfrom=&awardto=1001

  // 以&分隔字符串，获得类似name=xiaoli这样的元素数组
  let arr = str.split('&')
  let obj = new Object() // eslint-disable-line
  // 将每一个数组元素以=分隔并赋给obj对象
  for (let i = 0; i < arr.length; i++) {
    let tmpArr = arr[i].split('=')
    obj[decodeURIComponent(tmpArr[0])] = decodeURIComponent(tmpArr[1])
  }
  return obj[key] || ''
}

function add0(m){return m<10?'0'+m:m }
export const format = (shijianchuo) => {
  //shijianchuo是整数，否则要parseInt转换
  var time = new Date(shijianchuo);
  var y = time.getFullYear();
  var m = time.getMonth()+1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
}

export const formatDate = (shijianchuo) => {
  //shijianchuo是整数，否则要parseInt转换
  var time = new Date(shijianchuo);
  var y = time.getFullYear();
  var m = time.getMonth()+1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return y+'-'+add0(m)+'-'+add0(d);
}
